import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  providers: [DatePipe]
})
export class FooterComponent implements OnInit {

  currentDateAndTime: string;
  subscription: Subscription;

  constructor( private datePipe: DatePipe, ) {}
   
  ngOnInit(): void {
    this.currentDateAndTime = this.datePipe.transform(new Date(), 'MM-dd-yyyy HH:mm:ss');
    this.updateCurrentDateTime();
    this.subscription = interval(1000) // Update every second
      .subscribe(() => this.updateCurrentDateTime());
 }
  
 updateCurrentDateTime() {
   this.currentDateAndTime = this.datePipe.transform(new Date(), 'MM-dd-yyyy HH:mm:ss');
 }

}
